// File: custom-transition.js
// Import Highway
import Highway from './highway';
import gsap from 'gsap'
import stage from '../components/stage'

class CustomTransition extends Highway.Transition {
  // Built-in methods

  in({ from, to, trigger, done }) {

        
        
        window.lenis.scrollTo(0);

        from.remove();

         gsap.fromTo(to,
           {opacity: 0},
           {
            opacity: 1, duration: .71, ease: "power4.inOut",
            onComplete: done
           }
         );
        
         

  }

  out({ from, trigger, done }) {

   
    gsap.to(from,.71,
      {
       opacity: 0,
       ease: "power2.out",
       onComplete: done
      }
    );


  }
}

// Don`t forget to export your transition
export default CustomTransition;
